import { DownArrow } from 'components/Icons';
import React from 'react';

const LanguageSwitcher = ({ handleLanguageChange }) => {

    const handleLanguageChangeBound = () => {
        if (handleLanguageChange) {
            handleLanguageChange();
        }
    }
    return (
        <div className={'d-flex flex-row w-100 py-1 justify-content-center align-items-center language-switcher-container'}
            onClick={handleLanguageChangeBound}>
            <span className={'mr-1 text-light-gray font-size-12'}>English</span>
            <DownArrow />
        </div>
    )
}

export default LanguageSwitcher;
